const {
  VITE_API_URL = "http://localhost:3000/dev/v1",
  VITE_LEGACY_AI_URL,
  VITE_AUTH_URL,
  VITE_DD_CLIENT_TOKEN,
  VITE_DD_HOST,
  VITE_DD_APP_ID,
  VITE_DD_VERSION,
  VITE_CHAT_WS_URL,
  VITE_UPLOAD_API_URL,
  VITE_YJS_HOST,
  VITE_POSTHOG_KEY,
  VITE_POSTHOG_HOST,
  VITE_BASEPATH = "/",
  VITE_ASK_SURFACE = "",
} = import.meta.env;

export const API_URL = VITE_API_URL;
export const AUTH_URL = VITE_AUTH_URL;
export const DD_CLIENT_TOKEN = VITE_DD_CLIENT_TOKEN;
export const DD_HOST = VITE_DD_HOST;
export const DD_APP_ID = VITE_DD_APP_ID;
export const DD_VERSION = VITE_DD_VERSION;
export const CHAT_WS_URL = VITE_CHAT_WS_URL;
export const UPLOAD_API_URL = VITE_UPLOAD_API_URL;
export const LEGACY_AI_URL = VITE_LEGACY_AI_URL;
export const YJS_HOST = VITE_YJS_HOST;
export const POSTHOG_KEY = VITE_POSTHOG_KEY;
export const POSTHOG_HOST = VITE_POSTHOG_HOST;
export const BASEPATH = VITE_BASEPATH;
/** Local override to mount Ask V2 on localhost. Prefer `?surface=ask`. */
export const ASK_SURFACE_ENV = VITE_ASK_SURFACE;
